import Axios from "axios"
import { errorHandler, generateRequestHeaders } from "../../utils"
import api from '../../api'
import { TIMEOUT } from "../../constants"

const service = {
  async getData(id) {
    return new Promise(function(resolve, reject){
      if(id){
        Axios.get(`${api.base}${api.individu}${id}/`, {
          timeout: TIMEOUT,
          headers: generateRequestHeaders()
        }).then(res => {
          if(res.data){
            if(res.data.results) resolve(res.data.results)
            else resolve(res.data)
          }
          else{
            resolve(res)
          }
        }).catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },

  async join(id, organizationId) {
    return new Promise(function(resolve, reject){
      let requestBody = {
        joinRequest: [
          {
            organisasi: organizationId
          }
        ]
      }

      Axios.put(`${api.base}${api.individu_update}${id}/`, requestBody, {
        timeout: TIMEOUT,
        headers: generateRequestHeaders(),
      }).then(res => {
        if(res.data){
          resolve(res.data)
        }else{
          resolve(res)
        }
      }).catch(err => {
        const message = errorHandler(err)
        reject(message)
      })
    })
  },
}

export default service
